<!-- @format -->

<ng-container *transloco="let t">
  <app-cart-container [pageTitle]="'OPEN_UNIVERSITY.STUDY_VOUCHER_CONFIRMATION_COMPLETED.TITLE'">
    <fudis-grid [width]="'initial'" [rowGap]="'sm'" [classes]="'fudis-mt-sm'">
      <fudis-body-text>{{ t("OPEN_UNIVERSITY.STUDY_VOUCHER_CONFIRMATION_COMPLETED.DESC") }}</fudis-body-text>
      @if (enrolledItemsData$ | async; as enrolledItemsData) {
        @for (cartItem of openUniversityCart.items; track cartItem.localId) {
          <app-study-voucher-enrolled-item-info
            [cartItem]="cartItem"
            [openUniversityCart]="openUniversityCart"
            [openUniversityProducts]="enrolledItemsData.openUniversityProducts"
            [courseUnits]="enrolledItemsData.courseUnits"
            [assessmentItemsData]="enrolledItemsData.assessmentItemsData" />
        }
      }
      <fudis-heading [level]="2" [variant]="'lg'" class="fudis-mt-md">
        {{ t("OPEN_UNIVERSITY.STUDY_VOUCHER_CONFIRMATION_COMPLETED.INFO.TITLE") }}
      </fudis-heading>
      <fudis-body-text [variant]="'md-light'">{{ t("OPEN_UNIVERSITY.STUDY_VOUCHER_CONFIRMATION_COMPLETED.INFO.DESC1") }}</fudis-body-text>
      <fudis-body-text [variant]="'md-light'">{{ t("OPEN_UNIVERSITY.STUDY_VOUCHER_CONFIRMATION_COMPLETED.INFO.DESC2") }}</fudis-body-text>
      <fudis-body-text [variant]="'md-light'">{{ t("OPEN_UNIVERSITY.STUDY_VOUCHER_CONFIRMATION_COMPLETED.INFO.DESC3") }}</fudis-body-text>
      <fudis-grid-item [alignSelfX]="'center'" class="fudis-mt-sm">
        <fudis-button
          [variant]="'tertiary'"
          [label]="t('OPEN_UNIVERSITY.STUDY_VOUCHER_CONFIRMATION_COMPLETED.SEARCH_LINK')"
          data-cy="study-voucher-go-to-search-button"
          (handleClick)="goToSearch()" />
      </fudis-grid-item>
    </fudis-grid>
  </app-cart-container>
</ng-container>
